import api from './axiosInstance';

export const roleApi = {
  list: () => api.get('/roles'),
  getById: id => api.get(`/roles/${id}`),
  create: data => api.post('/roles', data),
  update: (id, data) => api.put(`/roles/${id}`, data),
  delete: id => api.delete(`/roles/${id}`),
  updatePermissions: (id, data) => api.put(`/roles/${id}/permissions`, data),
  listPermissions: () => api.get('/roles/permissions'),
};
